/**
 * All external URL links can be placed here.
 * It is structured in a way we can add multiple URLs from the same domain
 *
 * Example: EXTERNAL_LINKS = {
 *   "FUNCTIONALITY_1" : {
 *     baseUrl : 'https://domain1.com',
 *     url1 : '/func1/topic1',
 *     url2: '/func1/topic2'
 *     ....
 *   }
 *   "FUNCTIONALITY_2" : {
 *     baseUrl : 'https://domain2.com',
 *     ....
 *   }
 * }
 */

// This is not the full error message from the backend hence when checking for this message better to use "includes()".
// Intentionally having it all in lower case to avoid any mismatch
export const BAD_REQUEST_MP_ACCNT_ID_NOT_FOUND = 'marketplace account id not found';

export const EXTERNAL_LINKS = {
  LEGAL_MICROSITE: {
    // The legal microsite should be viewed as a whole
    baseUrl: 'https://cpl.thalesgroup.com/legal'
  },
  SUPPORT_PORTAL: {
    baseUrl: 'https://supportportal.thalesgroup.com',
    privacyNoticeUrl: '/csm?id=kb_article_view&sys_kb_id=6646d191db295344d298728dae96199c&sysparm_article=KB0017428',
    customerSupportUrl: '/csm'
  }
};

export enum CustomProduct {
  VPOP = 'ias4gc'
}

export enum CustomMode {
  Imperva = 'Imperva'
}

export const CustomProductToMode: Record<CustomProduct, CustomMode> = {
  [CustomProduct.VPOP]: CustomMode.Imperva
};
